
import React from 'react';
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";

interface ScenarioSelectorProps {
  scenarioType: string;
  setScenarioType: (value: string) => void;
  stressLevel: number[];
  setStressLevel: (value: number[]) => void;
  includeContingent: boolean;
  setIncludeContingent: (value: boolean) => void;
  includeUndrawn: boolean;
  setIncludeUndrawn: (value: boolean) => void;
}

const ScenarioSelector = ({
  scenarioType,
  setScenarioType,
  stressLevel,
  setStressLevel,
  includeContingent,
  setIncludeContingent,
  includeUndrawn,
  setIncludeUndrawn
}: ScenarioSelectorProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="scenario-type">Scenario Type</Label>
        <Select value={scenarioType} onValueChange={setScenarioType}>
          <SelectTrigger id="scenario-type">
            <SelectValue placeholder="Select scenario" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="baseline">Baseline</SelectItem>
            <SelectItem value="stressed">Stressed</SelectItem>
            <SelectItem value="severe">Severe Stress</SelectItem>
            <SelectItem value="recovery">Recovery</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="stress-level">Stress Level: {stressLevel[0]}%</Label>
        </div>
        <Slider
          id="stress-level"
          min={0}
          max={100}
          step={5}
          value={stressLevel}
          onValueChange={setStressLevel}
        />
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Label htmlFor="include-contingent">Include Contingent Cashflows</Label>
          <Switch 
            id="include-contingent" 
            checked={includeContingent} 
            onCheckedChange={setIncludeContingent} 
          />
        </div>
        
        <div className="flex items-center justify-between">
          <Label htmlFor="include-undrawn">Include Undrawn Commitments</Label>
          <Switch 
            id="include-undrawn" 
            checked={includeUndrawn} 
            onCheckedChange={setIncludeUndrawn} 
          />
        </div>
      </div>
    </div>
  );
};

export default ScenarioSelector;
